import {
    Grid,
    type GridProps,
    type PandaBreakpointConditions,
    type ResponsiveVariant,
} from "@octopus-energy/coral/atoms"
import { mergeResponsiveProps } from "@oefr/ui"
import { IconGridItems } from "./components/molecules/IconGridItems"

export type IconGridProps = Omit<GridProps, "gridTemplateColumns"> & {
    columns: ResponsiveVariant<number>
}

const DEFAULT_GRID_PROPS: GridProps = {
    gap: "md",
    alignItems: "center",
}

function getGridTemplateColumns(columns: ResponsiveVariant<number>) {
    if (typeof columns === "number") {
        return `repeat(${columns}, max-content 1fr)`
    }

    return Object.entries(columns).reduce<Partial<Record<keyof PandaBreakpointConditions, string>>>(
        (acc, [breakpoint, value]) => {
            acc[breakpoint as keyof PandaBreakpointConditions] = `repeat(${value}, max-content 1fr)`

            return acc
        },
        {}
    )
}

export function IconGrid(props: IconGridProps) {
    const gridProps = mergeResponsiveProps(DEFAULT_GRID_PROPS, {
        ...props,
        gridTemplateColumns: getGridTemplateColumns(props.columns),
    })

    return <Grid {...gridProps} />
}

IconGrid.Items = IconGridItems
